import getWrTetheredInjuredQbAlert from './wrTetheredInjuredQb';
import { parseExpectedReturnWeek, statusBucketLabel } from './injuryStatus';

const INSIGHT_LABELS = {
	high_impact: 'High impact',
	on_roster: 'On your rosters',
	high_exposure: 'High exposure',
	ir_return_timeline: 'IR timeline',
	qb_tether: 'QB tether'
};

export function buildInsightChips(player, teamQuarterbacksByTeamId = null) {
	const chips = [];
	const insights = player.insights || [];

	insights.forEach((key) => {
		if (INSIGHT_LABELS[key]) {
			chips.push({ key, label: INSIGHT_LABELS[key] });
		}
	});

	const returnWeek =
		player.expected_return_week || parseExpectedReturnWeek(player.status);
	if (returnWeek && !chips.some((c) => c.key === 'ir_return_timeline')) {
		chips.push({
			key: 'ir_return_timeline',
			label: `Return Week ${returnWeek}`
		});
	}

	const rosterChip =
		chips.find((c) => c.key === 'high_exposure') || chips.find((c) => c.key === 'on_roster');
	if (rosterChip && player.roster_exposure_pct > 0) {
		rosterChip.label = `${player.roster_exposure_pct}% exposure`;
	}

	const tetherAlert = getWrTetheredInjuredQbAlert(player, teamQuarterbacksByTeamId);
	if (tetherAlert && !chips.some((c) => c.key === 'qb_tether')) {
		chips.push({ key: 'qb_tether', label: 'QB tether', tooltip: tetherAlert.tooltipBody });
	}

	return chips;
}

export function formatImpactScore(score) {
	if (score == null) return '—';
	return Math.round(score);
}

export function playerProfilePath(player) {
	return `/players/${player.id}?position=${encodeURIComponent(player.position)}`;
}

export function statusFilterOptions(statusCounts = {}) {
	return Object.entries(statusCounts)
		.sort((a, b) => b[1] - a[1])
		.map(([label, count]) => ({
			value: label.toLowerCase().replace(/\s+/g, '_'),
			label: `${label} (${count})`
		}));
}

export function bucketFromFilterValue(value) {
	if (!value) return '';
	return value.replace(/_/g, ' ').toLowerCase();
}

export { statusBucketLabel };
